module.exports = __webpack_public_path__ + "images/back@1x.png?098f14e9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back@1x.png
// module id = 597
// module chunks = 7